module.exports = __webpack_public_path__ + "static/img/why-1.daec99f3.png";